import { axiosCompanyPortalInstance } from "./";

/**
 * Company Portal in-app notifications (PROLINE-2854).
 *
 * Base path (relative to the portal axios instance):
 *   /company_portal_notifications
 *
 * Endpoints:
 *   GET   /company_portal_notifications        -> list (resets unseen count to 0)
 *   PATCH /company_portal_notifications/:id     -> mark a single notification as seen
 */

/** GET /company_portal_notifications — `params`: `{ page, items, locale }`. */
const getCompanyPortalNotifications = async (params) =>
  await axiosCompanyPortalInstance.get(`/company_portal_notifications`, {
    params,
  });

/** PATCH /company_portal_notifications/:id — no body; backend sets `is_seen: true`. */
const setCompanyPortalNotificationSeen = async (id) =>
  await axiosCompanyPortalInstance.patch(`/company_portal_notifications/${id}`);

export { getCompanyPortalNotifications, setCompanyPortalNotificationSeen };
